import { Box, styled } from '@mui/material';

export const BaseChip = styled(Box)(() => ({
  display: 'flex',
  zIndex: '30',
  alignItems: 'center',
  borderRadius: '2px',
  boxSizing: 'border-box',
  minHeight: '16px',
  overflow: 'hidden',
  boxShadow: '0px 1px 18px rgba(0, 0, 0, 0.15)'
}));
